import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const facilityEquipmentRoutes: RouteObject[] = [
  {
    path: '/facility-equipments',
    element: lazyElement(() => import('./list/List')),
    handle: {
      documentTitle: 'Facility Equipment',
      crumb: () => ({ label: 'Facility Equipment', to: '/facility-equipments' })
    },
  },
];

export default facilityEquipmentRoutes;
